import { getDefaultImageAspectRatio } from '@app/ducks/helpers';
import { animated, SpringValue, to } from '@react-spring/web';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Placeholder } from '../CustomImage/Placeholder';

interface Props {
  alt?: string;
  src: string;
  slideSpring: {
    px: SpringValue<number>;
    py: SpringValue<number>;
    zoom: SpringValue<number>;
  };
  isActive: boolean;
  isPlaceholder: boolean;
}

export const ImageSlide = forwardRef<HTMLImageElement, Props>(
  ({ src, alt, isActive, isPlaceholder, slideSpring: { px, py, zoom } }, ref) => {
    const { t } = useTranslation(['common']);
    const transform = isActive ? to([px, py, zoom], (x, y, z) => `translate(${x}px, ${y}px) scale(${z})`) : undefined;
    const imageAspectRatio = useSelector(getDefaultImageAspectRatio);

    return (
      <div className="flex h-full w-full flex-1 flex-shrink-0 touch-none items-center justify-center overflow-hidden">
        {isPlaceholder ?
          <Placeholder aspectRatio={imageAspectRatio} shouldShowIcon>
            <div>{t('common:no_image')}</div>
          </Placeholder>
        : <animated.img
            ref={ref}
            alt={alt}
            src={src}
            draggable={false}
            className="max-h-full max-w-full object-contain"
            style={{
              touchAction: 'none',
              transform,
            }}
        />
        }
      </div>
    );
  },
);
